/*
(c) Copyright European Space Agency, 2023

Project name: THEMIS: Tracking the Health of the Environment and Missions in Space

Description:  Module for SpacecraftBarchart component
Author: Deimos Space UK

Version: 1.0
*/
import React, { useEffect, useState } from "react";
import { CardBody, Row, Alert } from "reactstrap";
import Chart from "react-apexcharts";
import { ESA_COLORS } from "../../../../core/models/colors";
import { useParams } from "react-router-dom";
import { getPetition } from "../../../../api/api";
import Spinner from 'react-bootstrap/Spinner';
import { saveFile, rawDataIntoExcel } from "../../../../api/excel-api";

export default function SpacecraftBarchart() {

  const { id } = useParams();
  const [data, setData] = useState({});
  const [labels, setLabels] = useState([]);
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)
  const [exporting, setExporting] = useState(false)
  const [minValue, setMinValue] = useState(0)
  const [maxValue, setMaxValue] = useState(0)


  useEffect(() => {
    getPetition(`/api/debris_index/share_of_debris_index_per_spacecraft_during_mission?mission_id=${id}`)
      .then((data) => {
        setSpaceCraft(data)
        setLoading(false)
        setError(false)
      })
      .catch((error) => {
        setError(true)
        setLoading(false)
      })
  }, [id]);

  const setDataKyes = (data) => {
    const keys = [];
    data.forEach(element => {
      const keyName = element.name
      keys.push(keyName);
    });
    setLabels(keys)

  }
  const setSpaceCraft = (spacecraft) => {
    const data = []
    if (spacecraft && spacecraft.spacecraft_debris_indices) {
      spacecraft.spacecraft_debris_indices.forEach(element => {
        const key = 'Spacecraft ' + element.spacecraft_id
        data.push(
          {
            "name": key, // "Spacecraft 1
            "Deployment": element.deployment,
            "Operational": element.operational,
            "Decommissioning": element.decommissioning,
          },

        )
      });
    }
    setMinMaxValue(data)
    setDataKyes(data)
    setData(data)
  }
  const setMinMaxValue = (data) => {
    let min = 0;
    let max = 0;
    data.forEach((spacecraft) => {
      if (spacecraft.Deployment < min) {
        min = spacecraft.Deployment
      }
      if (spacecraft.Operational < min) {
        min = spacecraft.Operational
      }
      if (spacecraft.Decommissioning < min) {
        min = spacecraft.Decommissioning
      }
      
      if(spacecraft.Deployment > max){
        max = spacecraft.Deployment
      }
      if(spacecraft.Operational > max){
        max = spacecraft.Operational
      }
      if(spacecraft.Decommissioning > max){
        max = spacecraft.Decommissioning
      }
      
    });
    setMinValue(min)
    setMaxValue(max)

      
  }
  const getBarChartData = () => {
    const barChartData = [
      {
        name: 'Deployment',
        data: []
      },
      {
        name: 'Operational',
        data: []
      }, {
        name: 'Decommissioning',
        data: []
      },

    ];
    if (data && data.length > 0) {

      data.forEach((spacecraft) => {
        barChartData[0].data.push(spacecraft.Deployment);
        barChartData[1].data.push(spacecraft.Operational);
        barChartData[2].data.push(spacecraft.Decommissioning);
    
      });
    }
    return barChartData;
  };
  const apexBarChartStackedOpts = {
    chart: {
      height: 380,
      type: "bar",
      stacked: true,
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      show: false,
    },
    xaxis: {
      categories: labels,
      labels: {
        formatter: function (val) {
          return val;
        },
      },
    },
    yaxis: {
      title: {
        text: undefined,
      },
      labels: {
        show: true,
        
        formatter: function (val) {
          return '[' + val.toExponential(3) + ']';
        },
       
      },
      min: minValue,
      max: maxValue
      
    },
    colors: ESA_COLORS,
    tooltip: {
      y: {
        formatter: function (val) {
          return '[' + val.toExponential(3) + ']';
        },
      },
    },
    fill: {
      opacity: 1,
    },
    states: {
      hover: {
        filter: "none",
      },
    },
    legend: {
      show: true
    },
    grid: {
      borderColor: "#f1f3fa",
    },
  };
  const fetchDataToExcel = () => {
    setExporting(true)
    getPetition(`/api/debris_index/share_of_debris_index_per_spacecraft_during_mission?mission_id=${id}`)
      .then((data) => {
        if (data && data.spacecraft_debris_indices) {
          let excelRows = data.spacecraft_debris_indices.map((item) => {
            return {
              "Spacecraft": item.spacecraft_id,
              "Injection": item.injection,
              "Launch": item.launch,
              "Operational": item.operational,
              "PMD": item.pmd
            }
          })
          const excelData = rawDataIntoExcel(excelRows, 'Share of debris index per spacecraft')
          saveFile(excelData, 'Share of debris index per spacecraft')
          setExporting(false)
        }
      })
      .catch((error) => {
        setExporting(false)
      })
  }



  return (
    <div className="widget-flat h-100" style={{
      background: 'white',
      boxShadow: '0px 0px 10px 0px rgba(0,0,0,0.06)',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
    }}>
      <CardBody>
        <Row style={{ display: 'flex', alignItems: 'center' }}>
          <h6 style={{ color: '#003247' }} className=" float-left col ">
            SHARE OF DEBRIS INDEX PER SPACECRAFT DURING THE MISSION
          </h6>

        </Row>
        {error ?
          (<div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignContent: 'center', marginTop: '20px', height: 'auto' }}>
            <Alert color="warning">
              <h4 className="alert-heading">No data available</h4>
              <p>
                There is no data available for this mission.
              </p>
            </Alert>
          </div>)
          :
          (loading ?
            <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignContent: 'center', marginTop: '20px', height: 'auto' }}>
              <Spinner animation="border" variant="primary" />
            </div>
            :
            <Chart
              options={apexBarChartStackedOpts}
              series={getBarChartData()}
              type="bar"
              className="apex-charts"
              height={'80%'}
            />
          )
        }

      </CardBody>
    </div>
  );
}
